// Centralized HTTP client (Axios version). Use Fetch if you prefer.
import axios from "axios";
import { API_BASE, API_PREFIX } from "../config/env";

// Compose the baseURL once, from runtime env.js
const BASE_URL = `${API_BASE.replace(/\/$/, "")}${API_PREFIX.startsWith("/") ? API_PREFIX : "/" + API_PREFIX}`;

export const http = axios.create({
  baseURL: BASE_URL, // e.g., http://localhost:8081/api
  // You can set timeout, headers, etc. here.
});

// Optional: attach token later (from Keycloak) without touching every call
export function setHttpAuthToken(token) {
  if (token) {
    http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete http.defaults.headers.common["Authorization"];
  }
}

// Optional: intercept responses for global error handling
// http.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     // handle 401, refresh token, etc.
//     return Promise.reject(err);
//   }
// );
